import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ItemReportContent from '../ItemReportContent';
import { setFromDate, setToDate, setSelectedBranch, fetchItemFullReport } from '../../../store/slices/itemReportSlice';

const ItemReport = () => {
    const dispatch = useDispatch();
    const storedBranchId = localStorage.getItem('branchid') || '';

    useEffect(() => {
        const toDate = new Date();
        const fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - 30);
        dispatch(setFromDate(fromDate));
        dispatch(setToDate(toDate));
        dispatch(setSelectedBranch({ branch_id: storedBranchId || 'All', branch_name: 'Branch' }));
        dispatch(
            fetchItemFullReport({
                fromDate,
                toDate,
                branchId: storedBranchId || 'All'
            })
        );
    }, [dispatch, storedBranchId]);

    return <ItemReportContent />;
};

export default ItemReport;
